import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/ImageX' /* webpackChunkName: "ImageX" */)],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('ImageX', UiTypes),
};

export default entry;
